import React from 'react';
interface SectionHeaderProps {
  label: string;
  className?: string;
  variant?: 'default' | 'hero';
}
export function SectionHeader({
  label,
  className = '',
  variant = 'default'
}: SectionHeaderProps) {
  return <div className={`flex justify-center relative z-10 ${className}`} data-id="element-274">
      <div className={`has-radius section-badge ${variant === 'hero' ? 'section-badge--hero' : ''}`} data-id="element-275">
        <span data-id="element-276">{label}</span>
      </div>
    </div>;
}